// src/components/Modals.js
import React, { useRef, useState } from "react";
import { Modal } from "./Modal";
import { FaTimes } from "react-icons/fa";
export const ValidationModal = ({
  modalOpen,
  modalMessage, 
  setModalOpen,
}) => {
  if (!modalOpen) return null;

  return (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
      }}
    >
      <div
        className="modal-content"
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          textAlign: "center",
        }}
      >
        <h2 style={{ margin: "10px 0" }}>Validation Result</h2>
        <p style={{ textAlign: "left" }}>{modalMessage}</p>
        <button
          onClick={() => setModalOpen(false)}
          style={{
            marginTop: "10px",
            padding: "8px 16px",
            border: "none",
            background: "#07b1b0",
            color: "white",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export const UploadModal = ({
  uploadModalOpen,
  setUploadModalOpen,
  currentDocType,
  dragging,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handleFileChange,
  file,
  fileName,
  fileDescriptions,
  handleDescriptionChange,
  certifiedCheckbox,
  setCertifiedCheckbox,
  handleFileUpload,
  onClose,

}) => {

  if (!uploadModalOpen) return null;


  return (
   <div style={{
  position: "fixed",
  top: "0",
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 10,
}}>
  <div style={{
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    width: "500px",
    maxWidth: "90vw",
    height:"425px",
    overflowY:"auto",
    position:"relative"
  }}>
    <FaTimes
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
            fontSize: "20px",
            color: "#333",
          }}
          aria-label="Close modal"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onClose();
          }}
        />
    <h3 style={{textAlign:"left"}}>Upload {currentDocType}</h3>

    <div className="file-upload-container">
      <div
        className={`drop-area ${dragging ? "drag-over" : ""}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <p>Drag & drop a file here or click Upload</p>
        <input type="file" id="fileInput" hidden onChange={handleFileChange} />
        <label htmlFor="fileInput" className={`upload-btn ${file ? "uploaded" : ""}`}>
          {file ? "✔ File Selected" : "Select File"}
        </label>
      </div>

      {/* ✅ File Name field */}
      <div className="form-group">
        <label htmlFor="fileName">File Name</label>
        <input
          type="text"
          id="fileName"
          className="file-name-input"
          value={fileName}
          disabled
           style={{ marginTop: 0 }}
        />
      </div>

      <div className="form-group">
        <label htmlFor="fileDescription">File Description</label>
        <input
          type="text"
          id="fileDescription"
          className="file-description-input"
          placeholder="Enter a brief description of the file"
          value={fileDescriptions[currentDocType] || ""}
          onChange={(event) => handleDescriptionChange(currentDocType, event)}
           style={{ marginTop: 0 }}
        />
      </div>

      <div style={{ marginTop: "15px", display: "flex", alignItems: "center", gap: "10px" }}>
        <label htmlFor="certifiedCheckbox" style={{ fontSize: "16px", fontWeight: "600", cursor: "pointer" }}>
          Is this a certified copy document?
        </label>
        <input
          id="certifiedCheckbox"
          type="checkbox"
          checked={certifiedCheckbox}
          onChange={(e) => setCertifiedCheckbox(e.target.checked)}
          style={{ transform: "scale(1.2)", cursor: "pointer" }}
        />
      </div>
    </div>

    <button className="submit-btn" onClick={handleFileUpload}>
      Submit Document
    </button>
  </div>
</div>

  );
};

export const PreviewModal = ({
  isOpen,
  onClose,
  docType,
  documents,
  optionalAttachments,
  modalRef,
  deleteDocument,
  setModalMessage,
  setModalOpen,
  previewFile
}) => {
  const fileUrl = previewFile?.file || documents[docType]?.file || optionalAttachments[docType]?.file;

  if (!isOpen || !docType || !fileUrl) {
    return null;
  }

  const cleanUrl = fileUrl.split("?")[0];
  const fileExt = cleanUrl.split(".").pop().toLowerCase();

  const renderPreview = () => {
    if (fileExt === "pdf") {
      return (
        <iframe
          key={fileUrl}
          src={fileUrl}
          width="100%"
          height="400px"
          style={{ border: "1px solid #ccc", borderRadius: "4px" }}
        />
      );
    } else if (["jpg", "jpeg", "png", "gif"].includes(fileExt)) {
      return (
        <div
          style={{
            maxWidth: "700px",
            margin: "0 auto",
            maxHeight: "90vh",
            overflow: "hidden",
            border: "1px solid #ccc",
            borderRadius: "4px",
            position: "relative",
            backgroundColor: "#2e2e2e"
          }}
        >
          {/* Toolbar */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "40px",
              backgroundColor: "#333",
              padding: "0 10px"
            }}
          >
            <a
              href={fileUrl}
              download
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "inline-flex", alignItems: "center", color: "white" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="white"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M5 20h14v-2H5v2zM12 2v12l4-4h-3V2h-2v8H8l4 4z" />
              </svg>
            </a>
          </div>

          {/* Image */}
          <div
            style={{
              overflow: "auto",
              maxHeight: "360px",
              textAlign: "center",
              padding: "8px",
              backgroundColor: "#fff"
            }}
          >
            <img
              src={fileUrl}
              alt={docType}
              onError={(e) => (e.target.style.display = "none")}
              style={{
                maxWidth: "100%",
                objectFit: "contain",
                borderRadius: "4px"
              }}
            />
          </div>
        </div>
      );
    } else if (["doc", "docx"].includes(fileExt)) {
      return (
        <p>
          Word documents cannot be previewed here.{" "}
          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#07b1b0" }}>
            Click here to download and view.
          </a>
        </p>
      );
    } else {
      return (
        <p>
          Preview not supported for this file type.{" "}
          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#07b1b0" }}>
            Download file
          </a>
        </p>
      );
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal" ref={modalRef}>
        <FaTimes
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
            fontSize: "20px",
            color: "#333",
          }}
          aria-label="Close modal"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onClose();
          }}
        />
        <h3>Viewing: {previewFile?.filename || docType}</h3>
        {renderPreview()}
        <button className="delete-btn" onClick={() => {
          const filename = previewFile?.filename || documents[docType]?.filename || optionalAttachments[docType]?.filename;
          if (filename) {
            deleteDocument(filename, docType);
          }
        }}>
          Delete Document
        </button>
      </div>
    </div>
  );
};